module.exports = __webpack_public_path__ + "img/2.eb3d92d9.png";